import { useCallback, useState } from "react";

// MUI
import { Grid } from "@mui/material";

// Components
import SearchInput from "@Layouts/components/Basics/SearchInput";
import { SectionDepartments } from "../components/SectionDepartments";

// Types
import { IDepartment } from "@/DataPages/types/timeAndPayRates/models";

// Helpers
import { debounceFn } from "@/Common/helpers/functions";

// Constants
import { DEBOUNCE_DELAY_500 } from "@/Constants/debounce";

type TPayRatesContentProps = {
	loading: boolean;
	isDataPresent: boolean;
	data: IDepartment[];
};

const PayRatesContent = (props: Readonly<TPayRatesContentProps>) => {
	const { loading, isDataPresent } = props;
	const [searchValue, setSearchValue] = useState<string>("");
	const [globalSearch, setGlobalSearch] = useState<string>("");

	const memoFn = useCallback(
		debounceFn((p: string) => setGlobalSearch(p), DEBOUNCE_DELAY_500),
		[]
	);

	const handleSearch = (value: string) => {
		setSearchValue(value);
		memoFn(value);
	};

	const shouldDisplayFlex = loading || isDataPresent ? "flex" : "none";

	function generateKey(value: string) {
		return value.replace(" ", "");
	}

	return (
		<>
			<Grid container mt={1} justifyContent={"flex-end"} display={shouldDisplayFlex}>
				<Grid item xs={3}>
					<SearchInput
						value={searchValue}
						loading={loading}
						onChange={handleSearch}
						clearSearch={() => {
							setSearchValue("");
							setGlobalSearch("");
						}}
						sx={{ display: shouldDisplayFlex }}
					/>
				</Grid>
			</Grid>
			<SectionDepartments {...props} searchValue={globalSearch} renderOption="payRates" generateKey={generateKey} />
		</>
	);
};

export default PayRatesContent;
